export default __webpack_public_path__ + "static/media/logo.48d6e0a7.png";